import React from "react";
import { Dialog, DialogContent, IconButton, styled } from "@mui/material";
import { ControlledTextField } from "../../components/inputs";
import { CloseSharp } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { Form, Title, Button } from "../../components";

const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    width: 100%;
  }
`;
const CloseIconButton = styled(IconButton)`
  position: absolute;
  top: 0;
  right: 0;
`;

const InformarMotivoAcaoDialog = ({
  handleSubmit,
  submitting,
  handleClose,
  formProps,
  open,
}) => {
  return (
    <StyledDialog
      onClose={() => {}}
      disableEscapeKeyDown
      maxWidth="sm"
      open={open}
    >
      <DialogContent>
        {!submitting && (
          <CloseIconButton onClick={handleClose}>
            <CloseSharp />
          </CloseIconButton>
        )}
        <Title as={"h2"} _margin_={"0 0 1rem 0"}>
          Informar o motivo da ação
        </Title>
        <Form onSubmit={handleSubmit}>
          <Grid container>
            <Grid item xs={12}>
              <ControlledTextField
                formProps={formProps}
                multiline={true}
                maxRows={8}
                minRows={4}
                name={"motivo"}
                label={"Comentários"}
              />
            </Grid>
          </Grid>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12} md={8}>
              <Button loading={submitting} type={"submit"} fullWidth>
                CONFIRMAR
              </Button>
            </Grid>
          </Grid>
        </Form>
      </DialogContent>
    </StyledDialog>
  );
};

export default InformarMotivoAcaoDialog;
